import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { set, unset } from 'lodash';

const getPersistedFormData = (): Record<string, any> => {
  try {
    const persistedState = localStorage.getItem('persist:root');
    if (!persistedState) return {};
    const parsedState = JSON.parse(persistedState);
    return parsedState?.multiStepForm
      ? JSON.parse(parsedState.multiStepForm).formData
      : {};
  } catch (error) {
    console.error('Error parsing persisted state:', error);
    return {};
  }
};

interface FormUiFlags {
  disableApplicantFields: boolean;
  hideApplicantFileUploader: boolean;
}

interface MultiStepFormState {
  formData: Record<string, any>;
  currentStep: number;
  lastVisitedFormKey: string;
  formUiFlags: FormUiFlags;
}

const initialState: MultiStepFormState = {
  formData: getPersistedFormData(),
  currentStep: 0,
  lastVisitedFormKey: '',
  formUiFlags: {
    disableApplicantFields: false,
    hideApplicantFileUploader: false,
  },
};

const multiStepFormSlice = createSlice({
  name: 'multiStepForm',
  initialState,
  reducers: {
    setApplicationData(state, action: PayloadAction<Record<string, any>>) {
      state.formData = action.payload;
    },
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    updateField(state, action: PayloadAction<{ field: string; value: any }>) {
      const { field, value } = action.payload;
      set(state.formData, field, value);
    },
    setLastVisitedFormKey(state, action: PayloadAction<string>) {
      state.lastVisitedFormKey = action.payload;
    },
    replaceArrayField(
      state,
      action: PayloadAction<{ field: string; value: any[] }>
    ) {
      set(state.formData, action.payload.field, action.payload.value);
    },
    resetForm(state) {
      state.formData = {};
      state.currentStep = 0;
      state.formUiFlags = {
        disableApplicantFields: false,
        hideApplicantFileUploader: false,
      };
    },
    setFormUiFlags(state, action: PayloadAction<Partial<FormUiFlags>>) {
      state.formUiFlags = {
        ...state.formUiFlags,
        ...action.payload,
      };
    },
  },
});

export const {
  setApplicationData,
  setCurrentStep,
  updateField,
  setLastVisitedFormKey,
  replaceArrayField,
  resetForm,
  setFormUiFlags,
} = multiStepFormSlice.actions;
export default multiStepFormSlice.reducer;
